import { RouteObject } from "react-router-dom";
import { routes } from "@songtradr-one/shared-common";
import { AuthRedirect } from "./AuthRedirect";

// LOADER

// WRAPPER

// ROUTE
export const AuthRedirectRoute: RouteObject[] = [
  {
    path: routes.authRedirect.base,
    Component: AuthRedirect,
  },
];
